

















































































































































































import { AgentModuleConfiguration, ClientAgent } from "@/models";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MatchProblemProduct from "@/models/Agents/MatchProblemProduct";
import MatchMultipleProductSelectPrincipalAccordion from "@/components/Agents/MatchMultipleProductSelectPrincipalAccordion.vue";
import { differentValues } from "@/utils/tableDifferencesVisualizer";
import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";

@Component({
  components: {
    MatchMultipleProductSelectPrincipalAccordion,
  },
})
export default class MatchConflictsProductPrincipalAccordionTable extends Vue {
  @Prop() readonly entities!: MatchProblemProduct[];
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  multipleProductsGroupNames: Set<string> = new Set();
  uniqueEntities: MatchProblemProduct[] = [];

  beforeMount() {
    this.setMultipleProductsGroupNames();
    this.setUniqueEntities();
    if (this.getMultipleProductsGroupNames().size) {
      this.$emit("multiple-product-presence", true);
    }
  }

  @Watch("multipleProductsGroupNames")
  onMultipleProductsGroupNamesPresent(value: Set<string>) {
    if (value.size) {
      this.$emit("multiple-product-presence", true);
    } else {
      this.$emit("multiple-product-presence", false);
    }
  }

  setMultipleProductsGroupNames(): void {
    this.multipleProductsGroupNames = new Set(
      this.entities
        .filter((product) => product.isMultiple)
        .map((product) => product.name)
    );
  }

  setUniqueEntities(): void {
    this.uniqueEntities = [
      ...this.entities.filter((product) => !product.isMultiple),
    ];
  }

  getMultipleProductsGroupNames(): Set<string> {
    return this.multipleProductsGroupNames;
  }

  getUniqueEntities(): MatchProblemProduct[] {
    return this.uniqueEntities;
  }

  getPrincipaProductlId(entity: MatchProblemProduct): string | number {
    return entity.principalProductId ?? "";
  }

  getPrincipalCompanyId(entity: MatchProblemProduct): string | number {
    return entity.principalCompanyId ?? "";
  }

  getAgentCompanyName(entity: MatchProblemProduct): string {
    return entity.agentCompany?.name ?? "";
  }

  getAgencyId(entity: MatchProblemProduct): string {
    return entity.currentAgency?.id ?? "";
  }

  getAgencyName(entity: MatchProblemProduct): string {
    return entity.currentAgency?.name ?? "";
  }

  getAgentCompanyAgentByType(
    agentType: string,
    entity: MatchProblemProduct
  ): ClientAgent | null {
    return (
      entity.currentAgentCompanyAgentAssociations?.find(
        (agentAss) => agentAss.agentType === agentType
      )?.agent || null
    );
  }

  getAgentCompanyAgentIdByType(
    agentType: string,
    entity: MatchProblemProduct
  ): string | null {
    return this.getAgentCompanyAgentByType(agentType, entity)?.id || null;
  }

  getAgentCompanyAgentNameByType(
    agentType: string,
    entity: MatchProblemProduct
  ): string | null {
    return this.getAgentCompanyAgentByType(agentType, entity)?.name || null;
  }

  isMatched(entity: MatchProblemProduct) {
    return entity.matched;
  }

  getMatchedStyle(entity: MatchProblemProduct) {
    return this.isMatched(entity) ? "matched-product" : "";
  }

  isMultiple(entity: MatchProblemProduct) {
    return entity.isMultiple;
  }

  differentValuesStyle(
    entities: ClientProductWithHierarchy[],
    property: keyof ClientProductWithHierarchy | null = null,
    func: Function | null = null,
    agentType: string | null = null
  ): string {
    return differentValues(entities, property, func, agentType)
      ? "difference-warning-field"
      : "";
  }
}
